import React from "react";
import { Grid, GridItem } from "styled-system/jsx";
import { CardNews } from "~/features/article";
import { INews } from "~/features/article/@types";
import { Wrapper } from "../shared/Wrapper";
import { EmptyState } from "./EmptyState";

interface CommunityProps {
  datum: INews[];
}

export const Community: React.FC<CommunityProps> = ({ datum }) => {
  return (
    <Wrapper title="Kabar Komunitas" subTitle="Temukan informasi kabar komunitas" to="/article/community">
      {datum.length === 0 ? (
        <EmptyState />
      ) : (
        <Grid
          gridTemplateColumns={{
            base: "1",
            sm: "2",
            lg: "3",
          }}
          mt={6}
        >
          {datum.map((v) => (
            <GridItem gridColumn="1" key={v.id}>
              <CardNews datum={v} hash="Kiat-kiat" />
            </GridItem>
          ))}
        </Grid>
      )}
    </Wrapper>
  );
};
